module.exports = __webpack_public_path__ + "static/img/challenge_warriors_bg.5203eb46.png";